export default "__VITE_ASSET__b05ad31c__"